module.exports = __webpack_public_path__ + "static/media/iso-2700120136034.818f2de5.jpg";